import { createFeature, createReducer, on } from '@ngrx/store';
import { RouteModels } from '@share-models';
import { RouteActions } from './route.actions';

export interface RouteState {
  breadcrumbs: RouteModels.UiBreadCrumbItem[];
}

const initialState: RouteState = {
  breadcrumbs: [],
};

export const routeFeature = createFeature({
  name: 'route',
  reducer: createReducer(
    initialState,
    on(RouteActions.setBreadcrumbs, (state, { breadcrumbs }) => ({
      ...state,
      breadcrumbs,
    })),
  ),
});
